import React from 'react';

function PremiumVersion() {
  return (
    <div className='premium-container'>
      <div className='premium-content'>
        <h2 className='premium-title'>Versión Premium en Desarrollo</h2>
        <p className='premium-text'>
          Actualmente, nuestro equipo está trabajando en la versión completa del producto. Esta nueva versión contará con características mejoradas y una funcionalidad optimizada para ofrecerle una experiencia aún más completa.
        </p>
        <p className='premium-text'>
          ¡Manténgase atento para más actualizaciones!
        </p>
      </div>
    </div>
  );
}

export default PremiumVersion;
